import {
  ArrowLeft2,
  ArrowRight2,
  DocumentDownload,
  SearchNormal,
  Sort,
} from "iconsax-react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getToken } from "../../../utils/token";
import instance from "../../../axios/instance";
import { PaginationButton } from "../../../components/PaginationButton";

export const invoicesLoader = async () => {
  const token = getToken();
  const res = await instance.get("/doctor/invoice/all", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return { invoices: res.data };
};

export function InvoicesPage() {
  const { invoices: _invoices } = useLoaderData();
  const [invoices, setInvoices] = useState(
    [..._invoices].map((_, index) => ({
      ..._,
      index: index + 1,
    }))
  );
  const [filteredInvoices, setFilteredInvoices] = useState(
    invoices.filter((_, index) => index + 1 <= 10)
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [sorted, setSorted] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();

    const query = searchQuery.toLowerCase();
    setFilteredInvoices(() => {
      return invoices.filter((invoice) => {
        const id = `${invoice.id}` === query;
        const facilityName = invoice.pharmacy.pharmacy_name
          .toLowerCase()
          .includes(query);
        const status = invoice.status.toLowerCase().includes(query);

        return id || facilityName || status;
      });
    });
  };

  useEffect(() => {
    setFilteredInvoices(() =>
      invoices.filter(
        (_, index) =>
          index + 1 > 10 * (pageIndex - 1) && index + 1 <= 10 * pageIndex
      )
    );
  }, [pageIndex]);

  const handleSort = (def) => {
    switch (def) {
      case "index": {
        setPageIndex(1);
        if (sorted !== "index") {
          setSorted("index");
        } else {
          setSorted("");
        }

        invoices.reverse();
        setInvoices(invoices);
        setFilteredInvoices((items) =>
          invoices.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "products": {
        setPageIndex(1);
        if (sorted === "products") {
          setSorted("");
          invoices.sort((a, b) => a.index - b.index);
        } else {
          setSorted("products");
          invoices.sort((a, b) => {
            if (a.orders.length < b.orders.length) return -1;
            if (a.orders.length > b.orders.length) return 1;
            return 0;
          });
        }
        setFilteredInvoices((items) =>
          invoices.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "total": {
        setPageIndex(1);
        if (sorted === "total") {
          setSorted("");
          invoices.sort((a, b) => a.index - b.index);
        } else {
          setSorted("total");
          invoices.sort((a, b) => {
            if (a.total < b.total) return -1;
            if (a.total > b.total) return 1;
            return 0;
          });
        }
        setFilteredInvoices((items) =>
          invoices.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "status": {
        setPageIndex(1);
        if (sorted === "status") {
          setSorted("");
          invoices.sort((a, b) => a.index - b.index);
        } else {
          setSorted("status");
          invoices.sort((a, b) => {
            if (a.payment_status < b.payment_status) return -1;
            if (a.payment_status > b.payment_status) return 1;
            return 0;
          });
        }
        setFilteredInvoices((items) =>
          invoices.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "date": {
        setPageIndex(1);
        if (sorted === "date") {
          setSorted("");
          invoices.sort((a, b) => a.index - b.index);
        } else {
          setSorted("date");
          invoices.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
        }
        setFilteredInvoices((items) =>
          invoices.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
    }
  };
  return (
    <div className="w-full px-7 py-5 bg-bg">
      <div className="text-2xl font-bold">All Invoices ({invoices.length})</div>

      <div className="border bg-white rounded-md overflow-x-scroll scrollbar-hide mt-4">
        <div className="flex justify-between p-2 items-center">
          <form className="relative" onSubmit={handleSearch}>
            <input
              className="outline-none h-[40px] w-[300px] border rounded-md p-2 placeholder placeholder:text-[14px] text-sm"
              placeholder="Search facility"
              name="query"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              className="absolute h-[38px] rounded-md top-1/2 -translate-y-1/2 right-[1px] w-[30px] flex items-center justify-center bg-white cursor-pointer hover:text-primary duration-300"
              type="submit"
            >
              <SearchNormal size={15} />
            </button>
          </form>

          <div className="flex gap-2 items-center">
            <PaginationButton
              item={<ArrowLeft2 size={16} />}
              disabled={pageIndex <= 1}
              handleClick={() => setPageIndex(pageIndex - 1)}
            />
            <span className="font-light text-xs">Page {pageIndex}</span>
            <PaginationButton
              item={<ArrowRight2 size={16} />}
              disabled={pageIndex >= Math.ceil(invoices.length / 10)}
              handleClick={() => setPageIndex((index) => index + 1)}
            />
          </div>
        </div>
        <div className="max-h-[80vh] overflow-y-scroll scrollbar-hide">
          <table className="w-full relative whitespace-nowrap">
            <thead>
              <tr className="uppercase h-14 font-bold bg-[#f1f1f1] text-gray-700 text-[12px]">
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("index")}
                >
                  #{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "index" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td className="px-6 py-4">Invoice ID</td>
                <td className="px-6 py-4">Pharmacy</td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("total")}
                >
                  Total{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "total" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("status")}
                >
                  Status{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "status" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("products")}
                >
                  Orders{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "products" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("date")}
                >
                  Date{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "date" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td></td>
              </tr>
            </thead>

            <tbody>
              {invoices.length < 1 ? (
                <tr>
                  <td className="px-6 py-4" colSpan={6}>
                    No invoices yet
                  </td>
                </tr>
              ) : (
                filteredInvoices.map((invoice, index) => (
                  <tr key={invoice.id} className="h-14 text-[14px] border-b">
                    <td className="px-6 py-4">{invoice.index}</td>
                    <td
                      className="px-6 py-4 underline text-primary cursor-pointer"
                      onClick={() =>
                        navigate(`/dashboard/invoices/${invoice.id}`)
                      }
                    >
                      {invoice.id}
                    </td>
                    <td className="px-6 py-4">{invoice.pharmacy.pharmacy_name}</td>
                    <td className="px-6 py-4">${invoice.total}</td>
                    <td className="px-6 py-4 capitalize">{invoice.payment_status}</td>
                    <td className="px-6 py-4 capitalize">
                      {invoice.orders.length}
                    </td>
                    <td className="px-6 py-4">
                      {
                        new Date(invoice.created_at)
                          .toLocaleString()
                          .split(",")[0]
                      }
                    </td>
                    <td
                      onClick={() => navigate(`/dashboard/invoices/${invoice.id}`)}
                      className="px-6 py-4 underline hover:text-primary cursor-pointer duration-300"
                    >
                      <DocumentDownload size={24} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
